import {
  ADD_ALL_PERSONAL_INFO,
  ADD_FIELD_COUNT,
  ADD_PERSONAL_INFO,
  RESET_STATE,
  SET_EMPTY,
  SET_MODIFIED,
} from "./actions";

const initialState = {
  personalInfo: {
    firstName: "",
    photo: "",
    mobile: "",
    email: "",
    experience: "",
    gender: "",
    BirthCertificate: "",
    dob: "",
    disability: [],
    orphan: "",
    address: [
      {
        address1: "",
        address2: "",
        addressType: "PERMANENT",
        city: "",
        state: "",
        pin: "",
      },
      {
        address1: "",
        address2: "",
        addressProof: "",
        addressType: "TEMPORARY",
        city: "",
        state: "",
        pin: "",
      },
    ],
    company: "",
    exp2: "",
  },
  count: { field1: 0, field2: 0 },
  modified: false,
  isEmpty: false,
};

const PersonalReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PERSONAL_INFO:
      let data = state.personalInfo;
      let isEmpty = state.isEmpty;
      if (!data.address.filter((a) => a.addressType === "TEMPORARY")[0]) {
        data.address = [
          ...data.address,
          {
            address1: "",
            address2: "",
            addressProof: "",
            addressType: "TEMPORARY",
            city: "",
            state: "",
            pin: "",
          },
        ];
        isEmpty = true;
      }

      let item = data.address.filter((a) => a.addressType === "TEMPORARY")[0];

      if (action.data.type === "addressType") {
      } else if (
        [
          "address1",
          "address2",
          "addressProof",
          "city",
          "state",
          "pin",
        ].includes(action.data.type)
      ) {
        // if (item) {
        console.log("in personal reducer", action.data);
        if (action.data.type.includes("city" || "state")) {
          if (action.data.value !== "") {
            item[action.data.type] = action.data.value;
          }
        } else {
          item[action.data.type] = action.data.value;
        }
        // }
      } else {
        if (action.data.type === "dob" && action.data.value !== "") {
          data[action.data.type] = action.data.value;
        } else if (
          (action.data.type === "disability" ||
            action.data.type === "experience") &&
          action.data.value !== ""
        ) {
          data[action.data.type] = action.data.value;
        } else {
          console.log("in reducer", action.data, data[action.data.type]);

          data[action.data.type] = action.data.value;
        }
      }
      return {
        ...state,
        modified: true,
        personalInfo: { ...data },
        isEmpty: isEmpty,
      };
    case ADD_ALL_PERSONAL_INFO:
      let data2 = state.personalInfo;
      // if(action.data.type === 'address'){
      //   data.address=action.data.value
      // }else{
      console.log("in personal reducer", action.data);

      data2 = { ...action.data };
      // if (!data2.BirthCertificate) {
        data2["BirthCertificate"] = "";
      // }
      // }
      return {
        ...state,
        personalInfo: { ...data2 },
      };
    case ADD_FIELD_COUNT:
      let data3 = state.count;
      // if(action.data.type === 'address'){
      //   data.address=action.data.value
      // }else{

      data3 = { ...data3, ...action.data };
      // }
      return {
        ...state,
        count: { ...data3 },
      };
    case SET_EMPTY:
      let data5 = state.isEmpty;
      data5 = action.data;
      return {
        ...state,
        isEmpty: data5,
      };
    case SET_MODIFIED:
      let data4 = state.modified;
      data4 = action.data;
      return {
        ...state,
        modified: { ...data4 },
      };
    case RESET_STATE:
      console.log("in personal empty reducer", action.data);

      return initialState;
    default:
      return state;
  }
};
export default PersonalReducer;
